import './bootstrapWebpack'; // Important that this come first, to bootstrap webpack settings
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-polyfills';
import patchMobX from 'owa-configure-mobx/lib/patchMobX';
import { configureMobX } from 'owa-configure-mobx/lib/configureMobX';

import { patchNode } from './patchNode';
// Configure MobX; this needs to happen ahead of other imports since Satchel stores are created as
// a side effect of importing
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function configureMobX called at module scope is not allowed. This may cause unwanted side effects. */
configureMobX();

// Monkey-patch MobX to proxy stale objects to the store
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function patchMobX called at module scope is not allowed. This may cause unwanted side effects. */
patchMobX();

// Monkey-patch DOM node APIs to avoid some component errors
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function patchNode called at module scope is not allowed. This may cause unwanted side effects. */
patchNode();
